import {CommonModule} from '@angular/common';
import {Component, inject} from '@angular/core';
import {FetchProductsStore} from '@em/data-feed/data-access-products';
import {
  EmBoxModule,
  EmSecondaryButtonComponent,
  EmSpinnerModule,
} from '@em/shared/ui';
import {TranslateModule} from '@ngx-translate/core';
import {EmFetchProductsInfoTextComponent} from '../fetch-products-info-text/fetch-products-info-text.component';

@Component({
  selector: 'em-fetch-products-info',
  imports: [
    CommonModule,
    TranslateModule,
    EmFetchProductsInfoTextComponent,
    EmSecondaryButtonComponent,
    EmSpinnerModule,
    EmBoxModule,
  ],
  templateUrl: './fetch-products-info.component.html',
  styleUrls: ['./fetch-products-info.component.scss'],
})
export class EmFetchProductsInfoComponent {
  private readonly _fetchProductsStore = inject(FetchProductsStore);

  protected inProgress$ = this._fetchProductsStore.inProgress$;

  triggerFetch() {
    this._fetchProductsStore.fetchProducts();
  }
}
